import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon } from '#const';
import { getIconUrl } from '#utils';

const QuoteAndStats = dynamic(() => import('./QuoteAndStats'));

export const defaultOptions = {
	quote:
		'Uber received a report of sexual assault or sexual misconduct in the United States almost every eight minutes',
	quoteFontSize: 38,
	quoteFontSizeMobile: 24,
	attribution: '- New York Times, Aug. 6, 2025',
	stats: [
		{ statName: 'Number of Uber Assault Victims', statFigure: '400,000+' },
		{ statName: 'Estimated Case Value*', statFigure: '$150,000+' },
		{ statName: 'Lawsuit Status', statFigure: 'Accepting New Claims' },
	],
	color: '#ffffff',
} as const;

Builder.registerComponent(QuoteAndStats, {
	name: 'QuoteAndStats',
	inputs: [
		{
			name: 'quote',
			friendlyName: 'Quote',
			type: 'longText',
			required: true,
			defaultValue: defaultOptions.quote,
			helperText:
				'Quote body text. The opening \u201C and closing \u201D marks are rendered automatically.',
		},
		{
			name: 'quoteFontSize',
			friendlyName: 'Quote Font Size (desktop, px)',
			type: 'number',
			required: false,
			defaultValue: defaultOptions.quoteFontSize,
			helperText: 'Font size of the quote text on desktop in px. Quote marks scale proportionally.',
		},
		{
			name: 'quoteFontSizeMobile',
			friendlyName: 'Quote Font Size (mobile, px)',
			type: 'number',
			required: false,
			defaultValue: defaultOptions.quoteFontSizeMobile,
			helperText: 'Font size of the quote text on mobile in px. Quote marks scale proportionally.',
		},
		{
			name: 'attribution',
			friendlyName: 'Attribution',
			type: 'string',
			required: false,
			defaultValue: defaultOptions.attribution,
			helperText: 'Attribution line below the quote (e.g. "- New York Times, Aug. 6, 2025")',
		},
		{
			name: 'stats',
			friendlyName: 'Stats',
			type: 'list',
			required: true,
			helperText: 'Add between 1 and 6 stat items.',
			subFields: [
				{ name: 'statName', friendlyName: 'Stat Name', type: 'string', required: true },
				{ name: 'statFigure', friendlyName: 'Stat Figure', type: 'string', required: true },
			],
			onChange: function (options) {
				const stats = options.get('stats');
				if (stats?.length > 6) {
					options.set('stats', stats.slice(0, 6));
					alert('Maximum stat items is 6, delete an item to continue.');
				} else if (!stats?.length) {
					alert('At least 1 stat item is required.');
				}
			},
			defaultValue: [...defaultOptions.stats],
		},
		{
			name: 'statNameBold',
			friendlyName: 'Bold Stat Names',
			type: 'boolean',
			required: false,
			defaultValue: true,
			helperText: 'When enabled, stat names are rendered in semi-bold. Disable for regular weight.',
		},
		{
			name: 'color',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: defaultOptions.color,
		},
		{
			name: 'textColor',
			friendlyName: 'Text Color',
			type: 'color',
			required: false,
			helperText: 'Overrides the text color for the entire section, including stat row dividers.',
		},
	],
	image: getIconUrl(Icon.IMAGE_TEXT_SECTION),
});
